export type AuthProviderName = "clerk" | "auth0";

export const AUTH0_DOMAIN =
  import.meta.env.VITE_AUTH0_DOMAIN || "dev-calone.eu.auth0.com";

export const AUTH0_CLIENT_ID =
  import.meta.env.VITE_AUTH0_CLIENT_ID || "HilBGuqcxXG1wdDsOPIcpSQK7jIUf4nX";

const configuredProvider = (import.meta.env.VITE_AUTH_PROVIDER ?? "auth0")
  .toLowerCase() as AuthProviderName;

export const defaultAuthProvider: AuthProviderName =
  configuredProvider === "clerk" ? "clerk" : "auth0";

export function isClerkRoute(pathname = window.location.pathname): boolean {
  return (
    pathname === "/clerk" ||
    pathname.startsWith("/clerk/") ||
    pathname === "/clerklogin" ||
    pathname.startsWith("/clerklogin/") ||
    pathname === "/clerkauth" ||
    pathname.startsWith("/clerkauth/")
  );
}

export function isAuth0Route(pathname = window.location.pathname): boolean {
  return (
    pathname === "/auth0" ||
    pathname.startsWith("/auth0/") ||
    pathname === "/login" ||
    pathname === "/register" ||
    pathname.startsWith("/auth/")
  );
}

export function getActiveAuthProvider(pathname = window.location.pathname): AuthProviderName {
  // 1. Explicit path overrides
  if (isClerkRoute(pathname)) {
    sessionStorage.setItem("active_auth_provider", "clerk");
    return "clerk";
  }
  if (isAuth0Route(pathname)) {
    sessionStorage.setItem("active_auth_provider", "auth0");
    return "auth0";
  }

  // 2. Explicit query param override (e.g. ?provider=clerk or ?provider=auth0)
  const params = new URLSearchParams(window.location.search);
  const urlProvider = params.get("provider")?.toLowerCase();
  if (urlProvider === "clerk" || urlProvider === "auth0") {
    sessionStorage.setItem("active_auth_provider", urlProvider);
    return urlProvider;
  }

  // 3. Stored provider for this browser tab/session.
  const storedProvider = sessionStorage.getItem("active_auth_provider");
  if (storedProvider === "auth0") return "auth0";
  // Ignore stored "clerk" preference outside of explicit /clerk* routes:
  // Clerk is legacy break-glass only, and the placeholder publishable key
  // used in preview environments will fail to authenticate.
  if (storedProvider === "clerk") {
    sessionStorage.removeItem("active_auth_provider");
  }

  // 4. Default fallback
  return defaultAuthProvider;
}

export function getRuntimeAuthProvider(pathname = window.location.pathname): AuthProviderName {
  return getActiveAuthProvider(pathname);
}

export const isAuth0Configured =
  Boolean(AUTH0_DOMAIN) &&
  Boolean(AUTH0_CLIENT_ID);
